import { Space, Typography } from 'antd'

const { Title, Text } = Typography

const Header = () => {
  return (
    <Space
      direction="vertical"
      size={13}
      align="center"
      style={{ textAlign: 'center' }}
    >
      <Title level={1} style={{ fontWeight: 'bold', margin: 0 }}>
        Seu período de teste terminou
      </Title>
      <Text type="secondary" style={{ fontSize: '16px' }}>
        Para continuar criando agentes, escolha um dos planos com descontos
        especiais
      </Text>
    </Space>
  )
}

export default Header
